import './ProviderShowComponent.css';

import { QuestionCircleOutlined }            from '@ant-design/icons';
import { EditOutlined }                      from '@ant-design/icons';
import { observer }                          from 'mobx-react';
import { Popconfirm }                        from 'antd';
import { Button }                            from 'antd';
import { DeleteOutlined }                    from '@ant-design/icons';
import { ApiCollection }                     from 'collections/ApiCollection';
import ProviderShowCategoryModel             from 'models/ProviderShowCategoryModel';
import ProviderShowModel                     from 'models/ProviderShowModel';
import { messageErrorIntl }                  from 'utils/messageIntl';
import { messageSuccessIntl }                from 'utils/messageIntl';
import Rights                                from 'utils/rights';
import { AppForm }                           from 'components/App/AppForm';
import ProviderShowForm                      from 'forms/ProviderShowForm';
import { getProviderAndProviderShowMixData } from 'utils/advertiserProviderTool';
import FormattedMessageWrapper               from 'components/App/FormattedMessageWrapper';
import ProviderModel                         from 'models/ProviderModel';

const ProviderShowComponent = ({
  displayRightComponent = true,
  onDeleteProviderShow,
  onSuccess = () => {
    // nothing
  },
  providerCollection,
  providerShow,
  providerShowCategory,
  providerShowCategoryCollection,
  withClicks = true,
}: {
  displayRightComponent?: boolean;
  onDeleteProviderShow?: () => void;
  onSuccess?: () => void;
  providerCollection: ApiCollection<ProviderModel>;
  providerShow: ProviderShowModel;
  providerShowCategory: ProviderShowCategoryModel;
  providerShowCategoryCollection: ApiCollection<ProviderShowCategoryModel>;
  withClicks?: boolean;
}) => {
  const providerFound = providerCollection.find(
    provider => provider.get('@id') === providerShow.get('provider'),
  ) as ProviderModel;

  if (!providerFound) {
    return null;
  }

  const { email, link, linkFull, name } = getProviderAndProviderShowMixData(
    providerFound,
    providerShow,
  );

  const deleteProviderShow = async (providerShowModel: ProviderShowModel) => {
    try {
      await providerShowModel.destroy();

      if (onDeleteProviderShow) {
        onDeleteProviderShow();
      }

      messageSuccessIntl("Suppression réussie !");
    } catch {
      messageErrorIntl("Impossible de supprimer.");
    }
  };

  return (
    <div className="ProviderShowComponent__container">
      <div
        className="ProviderShowComponent__providerShowInfos"
        style={{
          display: 'flex',
          width: '100%',
        }}
      >
        <div
          className="ProviderShowComponent__logo"
          style={{
            backgroundImage: `url(${providerFound.get('logo.objectUrl')})`,
          }}
        />

        <div style={{ flex: 1 }}>
          <div>{name}</div>
          {withClicks && <div>{email}</div>}
          <a
            href={linkFull}
            key={providerShow.get('@id')}
            onClick={() => {
              if (!withClicks) {
                providerShow.patch({ clicked: true });
              }
            }}
            rel="noreferrer"
            style={{
              lineBreak: 'anywhere',
              wordWrap: 'break-word',
            }}
            target="_blank"
          >
            {link}
          </a>
          {withClicks && <div>{providerShow.counter} clics</div>}
        </div>

        {displayRightComponent && (
          <div
            className="ProviderShowComponent__providerShowActions"
          >
            {Rights.for.provider.edit && (
              <Button
                htmlType="button"
                icon={<EditOutlined />}
                onClick={event => {
                  event.stopPropagation();
                  AppForm.open(ProviderShowForm, {
                    model: providerShow,
                    onSuccess,
                    providerCollection,
                    providerShowCategory,
                    providerShowCategoryCollection,
                  }, {
                    title: <FormattedMessageWrapper id="Modifier le prestataire" />,
                  });
                }}
              />
            )}

            {Rights.for.provider.delete && (
              <Popconfirm
                cancelText={<FormattedMessageWrapper id="Non" />}
                icon={<QuestionCircleOutlined style={{ color: '#e74c3c' }} />}
                okText={<FormattedMessageWrapper id="Oui" />}
                onCancel={event => event?.stopPropagation()}
                onConfirm={event => {
                  event?.stopPropagation();
                  deleteProviderShow(providerShow);
                }}
                placement="left"
                title={
                  <FormattedMessageWrapper id="Êtes-vous sûr de vouloir supprimer ce prestataire ?" />
                }
              >
                <Button
                  htmlType="button"
                  icon={<DeleteOutlined />}
                  onClick={event => {
                    event.stopPropagation();
                  }}
                />
              </Popconfirm>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const ProviderShowComponentObserver = observer(ProviderShowComponent);

export default ProviderShowComponentObserver;
